import { validators, formats, dates } from 'investira.sdk';
import { Tooltip, Stack, Chip, Typography, Icon } from 'investira.react.components';
import { OUTPUT, CONFERENCIA_CUSTODIANTE_STATUS } from '../../enums';

const columns = {
  [OUTPUT.duration.id]: [
    {
      id: 'criacao',
      accessorKey: 'created',
      header: 'Criação',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      maxSize: 100,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'carteira',
      accessorKey: 'request_metadata.carteira',
      header: 'Carteira',
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'multi-select',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'posicao',
      accessorKey: 'request',
      header: 'Data Posição',
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue().data));
      }
    },
    {
      id: 'juros',
      accessorKey: 'request',
      header: 'Juros Delta',
      enableColumnActions: false,
      enableSorting: true,
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: 'right'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue().juros_delta)) {
          return null;
        }
        return `${cell.getValue().juros_delta.toFixed(4)}%`;
      }
    },
    {
      id: 'username',
      accessorKey: 'request_metadata.username',
      header: 'Usuário',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }
  ],
  [OUTPUT.enquadramento.id]: [
    {
      id: 'created',
      accessorKey: 'created',
      header: 'Criação',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      maxSize: 100,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'carteira_portfolio',
      accessorKey: 'request_metadata',
      header: 'Carteira / Portfólio',
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'multi-select',
      Cell: ({ cell }) => {
        if (
          validators.isNull(cell.getValue().carteira) &&
          validators.isNull(cell.getValue().portfolio)
        ) {
          return;
        }
        return cell.getValue().carteira || cell.getValue().portfolio;
      }
    },
    {
      id: 'data_posicao',
      accessorKey: 'posicao',
      header: 'Data Posição',
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'date-range',
      maxSize: 100,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'enquadramento',
      accessorKey: 'request_metadata.enquadramento',
      header: 'Enquadramento',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'consolidacao_por_emissor',
      accessorKey: 'request_metadata',
      header: 'Consolidação por Emissor',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue()?.consolidacao)) {
          return;
        }
        //Individual
        //Carteira Próprias
        //Carteiras do Portfólio
        return cell.getValue()?.consolidacao;
      }
    },
    {
      id: 'username',
      accessorKey: 'request_metadata.username',
      header: 'Usuário',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }
  ],
  [OUTPUT.stresstest.id]: [
    {
      id: 'criacao',
      accessorKey: 'created',
      header: 'Criação',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'carteira',
      accessorKey: 'request_metadata.carteira',
      header: 'Carteira',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      filterVariant: 'multi-select'
    },
    {
      id: 'posicao',
      accessorKey: 'request',
      header: 'Data Posição',
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue().data));
      }
    },
    {
      id: 'amostragem',
      accessorKey: 'request.dias',
      header: 'Amostragem',
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 100,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return `${cell.getValue()} dias`;
      }
    },
    {
      id: 'simulacao',
      accessorKey: 'request.simulacao',
      header: 'Simulação',
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 100,
      Cell: ({ cell }) => {
        if (validators.isEmpty(cell.getValue())) {
          return 'Nenhuma';
        }
        return `${Object.keys(cell.getValue())
          .map(x => x)
          .join(', ')}`;
      }
    },
    {
      id: 'username',
      accessorKey: 'request_metadata.username',
      header: 'Usuário',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }
  ],
  [OUTPUT.rentabilidade.id]: [
    {
      id: 'carteira',
      accessorKey: 'carteira_id',
      header: 'Carteira',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false
    },
    {
      id: 'posicao',
      accessorKey: 'data_posicao',
      header: 'Data Posição',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'data',
      accessorKey: 'data',
      header: 'Data',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'juros',
      accessorKey: 'payload.juros_delta',
      header: 'Juros Delta',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return `${cell.getValue().toFixed(4)}%`;
      }
    },
    {
      id: 'logid',
      accessorKey: 'log_id',
      header: 'Log ID',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false
    },
    {
      id: 'criacao',
      accessorKey: 'created',
      header: 'Criação',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'usuario_id',
      accessorKey: 'usuario_id',
      header: 'Usuário',
      enableColumnActions: false,
      enableSorting: true,
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: 'right'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    },
    {
      id: 'status',
      accessorKey: 'processamento_arquivo',
      header: 'Status',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: xProps => {
        const { cell, row } = xProps;

        if (!validators.isEmpty(row.original.processamento_erros)) {
          const xError = row.original.processamento_erros;
          return (
            <Tooltip
              arrow
              title={
                <Stack
                  spacing={1}
                  sx={{
                    px: 3,
                    py: 2,

                    whiteSpace: 'normal'
                  }}>
                  <Stack spacing={1}>
                    <Typography variant="caption" color="textPrimary">
                      {xError.description || xError}
                    </Typography>
                  </Stack>
                </Stack>
              }>
              <span>
                <Chip size="small" label="Erro" color="error" />
              </span>
            </Tooltip>
          );
        }

        if (validators.isNull(cell.getValue())) {
          return <Chip size="small" label="Processando" color="warn" />;
        }

        return <Chip size="small" label="Ok" color="success" />;
      }
    }
  ],
  [OUTPUT.var.id]: [
    {
      id: 'criacao',
      accessorKey: 'created',
      header: 'Criação',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      maxSize: 100,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'carteira',
      accessorKey: 'request_metadata.carteira',
      header: 'Carteira',
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'multi-select',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'posicao',
      accessorKey: 'request',
      header: (
        <Typography variant="caption">
          <b>
            Data
            <br />
            Posição
          </b>
        </Typography>
      ),
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'date-range',
      maxSize: 85,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue().data));
      }
    },
    {
      id: 'indicador',
      accessorKey: 'request.indicador_id',
      header: 'Indicador',
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 65,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return 'Nenhum';
        }
        return cell.getValue();
      }
    },
    {
      id: 'amostragem',
      accessorKey: 'request.dias',
      header: 'Amostragem',
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 85,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return `${cell.getValue()} dias`;
      }
    },
    {
      id: 'confiancas',
      accessorKey: 'request.confiancas',
      header: 'Confiança',
      muiTableHeadCellProps: {
        align: 'right'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 65,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return `${cell.getValue()}%`;
      }
    },
    {
      id: 'peso_ewma',
      accessorKey: 'request.peso_ewma',
      header: (
        <Typography variant="caption">
          <b>
            Lambda
            <br />
            EWMA
          </b>
        </Typography>
      ),
      muiTableHeadCellProps: {
        align: 'right'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 60,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'dias_ewma',
      accessorKey: 'request.dias_ewma',
      header: (
        <Typography variant="caption">
          <b>
            Dias
            <br />
            EWMA
          </b>
        </Typography>
      ),
      muiTableHeadCellProps: {
        align: 'right'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 50,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'juros',
      accessorKey: 'request.juros',
      header: (
        <Typography variant="caption">
          <b>
            Juros
            <br />
            Livre
          </b>
        </Typography>
      ),
      muiTableHeadCellProps: {
        align: 'right'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 90,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatNumber(cell.getValue(), 3, true);
      }
    },
    {
      id: 'aberta',
      accessorKey: 'request.aberta',
      header: 'Posição',
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 50,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }

        return cell.getValue() === true ? (
          <Chip
            icon={<Icon iconName="box_3d_open" size={18} />}
            label="Aberta"
            color="warning"
            size="small"
            sx={{ px: 1 }}
            variant="filled"
          />
        ) : (
          <Chip
            icon={<Icon iconName="box_3d" size={18} />}
            label="Fechada"
            color="warning"
            size="small"
            sx={{ px: 1 }}
            variant="filled"
          />
        );
      }
    },
    {
      id: 'username',
      accessorKey: 'request_metadata.username',
      header: 'Usuário',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }
  ],
  [OUTPUT.conferenciacustodiante.id]: [
    {
      id: 'criacao',
      accessorKey: 'created',
      header: 'Criação',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      maxSize: 100,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    },
    {
      id: 'carteira',
      accessorKey: 'request_metadata.carteira',
      header: 'Carteira',
      enableColumnActions: false,
      enableSorting: false,
      filterVariant: 'multi-select',
      muiTableHeadCellProps: {
        sx: {
          width: '50% !important'
        }
      },
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'posicao',
      accessorKey: 'posicao',
      header: 'Data Posição',
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 100,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue();
      }
    },
    {
      id: 'status',
      accessorKey: 'request_metadata.status',
      header: 'Status',
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 50,
      muiTableHeadCellProps: {
        align: 'center'
      },
      muiTableBodyCellProps: {
        align: 'center'
      },
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }

        const xConferenciaCustodianteStatus = CONFERENCIA_CUSTODIANTE_STATUS[cell.getValue()];

        return (
          <Chip
            label={xConferenciaCustodianteStatus.descricao}
            color={xConferenciaCustodianteStatus.color}
            size="small"
            sx={{ px: 1 }}
            variant="filled"
          />
        );
      }
    },
    {
      id: 'username',
      accessorKey: 'request_metadata.username',
      header: 'Usuário',
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }
  ]
};

export default columns;
